<template>
  <div class="unit-info-container">
    <div class="info-card">
      <div class="card-header">
        <h2>单位信息填写</h2>
        <p class="subtitle">请填写您的单位信息，完成后即可正常使用系统</p>
      </div>

      <el-form
        ref="unitForm"
        :model="unitForm"
        :rules="formRules"
        label-width="120px"
        class="unit-form"
      >
        <el-form-item label="单位名称" prop="organizationName">
          <el-input
            v-model="unitForm.organizationName"
            placeholder="请输入单位名称"
            maxlength="100"
          />
        </el-form-item>

        <el-form-item label="单位类型" prop="organizationType">
          <el-select
            v-model="unitForm.organizationType"
            placeholder="请选择单位类型"
            style="width: 100%"
          >
            <el-option label="学校" value="school" />
            <el-option label="培训机构" value="training" />
            <el-option label="企业" value="enterprise" />
            <el-option label="其他" value="other" />
          </el-select>
        </el-form-item>

        <el-form-item label="所在地区" prop="region">
          <el-cascader
            v-model="unitForm.region"
            :options="regionOptions"
            placeholder="请选择所在地区"
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="unitForm.address"
            placeholder="请输入详细地址"
            maxlength="200"
          />
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input
            v-model="unitForm.phone"
            placeholder="请输入联系电话"
            maxlength="20"
          />
        </el-form-item>

        <el-form-item label="单位简介" prop="description">
          <el-input
            v-model="unitForm.description"
            type="textarea"
            :rows="4"
            placeholder="请输入单位简介（选填）"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            @click="submitForm"
            style="width: 100%"
          >
            提交信息
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updateUser } from '@/api/user'
import { Message } from 'element-ui'
import { updateUserStatus } from '@/utils/userStatus'

export default {
  name: 'UnitInfo',
  data() {
    return {
      loading: false,
      unitForm: {
        organizationName: '',
        organizationType: '',
        region: [],
        address: '',
        phone: '',
        description: ''
      },
      formRules: {
        organizationName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        organizationType: [
          { required: true, message: '请选择单位类型', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择所在地区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/, message: '请输入正确的联系电话格式', trigger: 'blur' }
        ]
      },
      regionOptions: [
        {
          value: 'beijing',
          label: '北京市',
          children: [
            { value: 'beijing', label: '北京市' }
          ]
        },
        {
          value: 'shanghai',
          label: '上海市',
          children: [
            { value: 'shanghai', label: '上海市' }
          ]
        },
        {
          value: 'guangdong',
          label: '广东省',
          children: [
            { value: 'guangzhou', label: '广州市' },
            { value: 'shenzhen', label: '深圳市' }
          ]
        }
        // 这里可以添加更多地区选项
      ]
    }
  },
  methods: {
    submitForm() {
      this.$refs.unitForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'))
            const submitData = {
              userId: userInfo.id,
              organizationName: this.unitForm.organizationName,
              organizationType: this.unitForm.organizationType,
              region: this.unitForm.region.join('/'),
              address: this.unitForm.address,
              phone: this.unitForm.phone,
              description: this.unitForm.description,
              mark: 1 // 更新mark字段为1，表示已完成单位信息填写
            }

            const response = await updateUser(submitData)
            if (response.code === 1) {
              Message.success('单位信息提交成功！')
              // 更新本地存储中的用户信息
              updateUserStatus('mark', 1)
              // 跳转到主页
              this.$router.push('/')
            } else {
              Message.error(response.msg || '提交失败，请重试')
            }
          } catch (error) {
            Message.error('提交失败，请重试')
            console.error('提交单位信息失败:', error)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.unit-info-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.info-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 600px;
}

.card-header {
  text-align: center;
  margin-bottom: 30px;

  h2 {
    color: #333;
    margin-bottom: 10px;
    font-size: 28px;
  }

  .subtitle {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

.unit-form {
  .el-form-item {
    margin-bottom: 25px;
  }

  .el-input,
  .el-select,
  .el-cascader {
    .el-input__inner {
      border-radius: 8px;
      border: 1px solid #dcdfe6;

      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }
  }

  .el-button {
    border-radius: 8px;
    height: 44px;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
